import { Directive, effect, input, signal } from '@angular/core'

import { IconPosition, fonts, theme } from '@flowx/core-sdk'
import { ButtonStyles, applyButtonCustomStyles } from '@flowx/core-theme'

@Directive({
  selector: 'button[flxButton],a[flxButton]',
  host: {
    '[class]': 'styleClassName()',
  },
  standalone: true,
})
export class FlxButtonStyleDirective {
  componentStyle = input<{
    style: ButtonStyles
    type: 'ghost' | 'fill' | 'text'
    iconPosition?: IconPosition
  }>()

  styleClassName = signal<string>('')

  constructor() {
    effect(async () => {
      const className = await applyButtonCustomStyles(
        this.componentStyle().style,
        this.componentStyle().type || 'ghost',
        theme(),
        fonts(),
        this.componentStyle().iconPosition
      )
      this.styleClassName.set(className)
    })
  }
}
